export var menus = document.getElementsByClassName('dropDown-menu');

[].forEach.call(menus, function (m) {
    
    m.addEventListener('click', function () {
        m.classList.toggle('open');
    });
    m.addEventListener('click', function () {
        m.classList.toggle('display');
    });

});

// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import slick from "slick-carousel";

